import React, { useEffect, useState } from "react";
import "./earnings-invoice.scss";
import { useTranslation } from "react-i18next";
import {
  Row,
  Radio,
  Col,
  Card,
  Tag,
  Button,
  Table,
  Input,
  Divider,
  Space,
  Dropdown,
  Spin,
  Modal,
  Form,
  Select,
  DatePicker,
  Tabs,
  Drawer,
  Pagination,
} from "antd";

import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import addFrame from "../../assets/images/earning-invoice-addFrame.svg";
import calendar from "../../assets/images/earning-invoice-calender.svg";
import leftArrow from "../../assets/images/earning-invoice-left-arrow.svg";
import plus from "../../assets/images/earning-invoice-plus.svg";
import CalendarImg from "../../assets/images/calendar-icon.svg";

import { useLocation, useNavigate } from "react-router-dom";
import InvoiceCard from "./components/invoice-card";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  getInvoiceStatusList,
  getVendorInvoiceDetail,
  getVendorInvoiceDraftDetail,
  getVendorInvoiceDraftList,
  getVendorSubmittedInvoiceList,
} from "../../service/earning-invoice/earning-invoice";
import InvoiceDetailsDrawerContent from "./components/invoice-details-drawer-content";
import TripDetailsModal from "./components/trip-details-modal";
import { useStore } from "../../store/store";
import * as localStorageService from "../../service/localStorageService";

const { Option } = Select;
dayjs.extend(utc);
const EarningInvoice = () => {
  const { t } = useTranslation();
  const { user } = useStore();
  const { RangePicker } = DatePicker;
  const [activeTab, setActiveTab] = useState("drafts");
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [selectedHeaderInvoiceId, setSelectedHeaderInvoiceId] = useState(null);
  console.log("selectedInvoiceId", selectedInvoiceId);
  const [invoiceList, setInvoiceList] = useState([]);
  const [invoiceStatusList, setInvoiceStatusList] = useState([]);
  const [statusLoading, setStatusLoading] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [formFilterState, setFormFilterState] = useState({
    invoiceStatus: "",
    fromDate: dayjs().startOf("month").utc(true).toISOString(),
    toDate: dayjs().endOf("month").utc(true).toISOString(),
  });
  const [tripModalOpen, setTripModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isApplyFilter,setIsApplyFilter] =useState(false);
  // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize,setPageSize] = useState(20);
    const [totalRecord, setTotalRecord] = useState(0);
    const [isPageChange, setPageChange] = useState(false);


  const navigate = useNavigate();
  const location = useLocation();
  const invoiceId = location?.state?.invoiceId;


    useEffect(() => {
    if (invoiceId) {
      setActiveTab("submitted")
      setSelectedHeaderInvoiceId(invoiceId);
      handleInvoiceClick(invoiceId);
      
       navigate("/earnings/invoice-upload", { replace: true });
    }
  }, [invoiceId]);

  const fetchInvoices = async () => {
    try {
      setLoading(true);
      setInvoiceList([]);
      const payload = {
        pageNumber:currentPage,
        pageSize: pageSize,
        fromDate: formFilterState.fromDate,
        toDate: formFilterState.toDate,
        status: formFilterState.invoiceStatus,
        searchText: debouncedSearch,
      };

      const payloadDraft = {
        pageNumber: currentPage,
        pageSize: pageSize,
        fromDate: formFilterState.fromDate,
        toDate: formFilterState.toDate,
      };

      let res;

      if (activeTab === "drafts") {
        res = await getVendorInvoiceDraftList(payloadDraft);
      } else {
        res = await getVendorSubmittedInvoiceList(payload);
      }
       
      setInvoiceList(res?.data?.data || []);
      setTotalRecord(res?.data?.pagination?.totalRecords || 0);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchInvoiceStatusList = async () => {
    try {
      setStatusLoading(true);

      const res = await getInvoiceStatusList();

      setInvoiceStatusList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setStatusLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchText);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchText]);

  useEffect(() => {
    if(isApplyFilter){
      fetchInvoices();
      setIsApplyFilter(false);
    }
  }, [isApplyFilter]);

  useEffect(() => {
      fetchInvoices();
  if (activeTab === "submitted" && invoiceStatusList.length === 0) {
      fetchInvoiceStatusList();
    }
  }, [activeTab]);

  useEffect(() => {
    if (!selectedInvoiceId) return;

    const fetchInvoiceDetails = async () => {
      try {
        setDetailsLoading(true);

        let res;

        if (activeTab === "drafts") {
          res = await getVendorInvoiceDraftDetail(selectedInvoiceId);
        } else {
          res = await getVendorInvoiceDetail(selectedInvoiceId);
        }

        setInvoiceDetails(res?.data?.data || null);
      } catch (err) {
        console.error(err);
      } finally {
        setDetailsLoading(false);
      }
    };

    fetchInvoiceDetails();
  }, [selectedInvoiceId, activeTab]);

  useEffect(()=>{
    if(isPageChange){
      fetchInvoices();
      setPageChange(false);
    }
  },[isPageChange]);

  useEffect(()=>{
  if (!formFilterState?.fromDate || !formFilterState?.toDate) return;
  const formattedData = {
    fromDate: dayjs(formFilterState.fromDate).utc().format("YYYY-MM-DD"),
    toDate: dayjs(formFilterState.toDate).utc().format("YYYY-MM-DD"),
  };

  localStorageService.setKey("invoiceDateRange", formattedData);
  },[formFilterState.fromDate,formFilterState.toDate]);

  const handleAddInvoice = () => {
    navigate("/earnings/add-new-invoice");
  };

  const format = "DD/MM/YYYY";

  const handleDateChange = (dates) => {
    if (!dates) return;

    setFormFilterState((prev) => ({
      ...prev,
      fromDate: dates[0]?.utc(true).toISOString(),
      toDate: dates[1]?.utc(true).toISOString(),
    }));
  };

  const handleOrderClick = (order) => {
    setSelectedOrder(order);
    setTripModalOpen(true);
  };

  const handleInvoiceClick = (id) => {
    setSelectedInvoiceId(id);
    setDrawerOpen(true);
  };

  const onClose = () => {
    setSelectedInvoiceId(null);
    setDrawerOpen(false);
  };

  const handleTabsChange=(value)=>{
    setCurrentPage(1);
    setSearchText("");
    setDebouncedSearch("");
    setFormFilterState({
    invoiceStatus: "",
    fromDate: dayjs().startOf("month").utc(true).toISOString(),
    toDate: dayjs().endOf("month").utc(true).toISOString(),
    });

    setActiveTab(value);
  }

  const handleApplyFilter =()=>{
      setCurrentPage(1);
      setIsApplyFilter(true);
  }

  const handleResetFilter =()=>{
    setCurrentPage(1);
    setSearchText("");
    setDebouncedSearch("");
    setFormFilterState({
    invoiceStatus: "",
    fromDate: dayjs().startOf("month").utc(true).toISOString(),
    toDate: dayjs().endOf("month").utc(true).toISOString(),
    });
   setIsApplyFilter(true);
  }

const handleChangePage =(page)=>{
  setCurrentPage(page);
  setPageChange(true);
}

const handleBackBtnClick =()=>{
  navigate("/earnings");
}

  return (
    <>
      <div className="earning-invoice-wrapper">
          <div>
            <Row className="invoice-btn-row">
              <div className="invoice-upload">
                <img style={{cursor:"pointer"}} onClick={handleBackBtnClick} src={leftArrow} alt="icon" /> {t("INV_UPLOAD_HEADING")}
              </div>
              <div className="add-new-invoice" onClick={handleAddInvoice}>
                <Button className="add-new-btn">
                  <img src={plus} alt="+" />
                  {t("INV_UPLOAD_ADD_NEW_INV_BTN")}
                </Button>
              </div>
            </Row>
            <div className="tab-wrapper">
              <Row className="" justify={"space-between"}>
                <Space>
                  <Button
                    className={`tab-btn ${activeTab === "drafts" ? "active" : ""}`}
                    onClick={() => handleTabsChange("drafts")}
                  >
                    {t("INV_UPLOAD_DRAFT_HEADING")}
                  </Button>

                  <Button
                    className={`tab-btn ${activeTab === "submitted" ? "active" : ""}`}
                    onClick={() => handleTabsChange("submitted")}
                  >
                    {t("INV_UPLOAD_SUBMITTED_HEADING")}
                  </Button>
                </Space>
              </Row>
            </div>

            <Row
              gutter={[16, 16]}
              align="middle"
              className="invoice-filters-row"
            >
              {/* Search */}
              {activeTab === "submitted" && (
              <Col xs={24} md={8} lg={6}>
                <Input
                  placeholder={t("INV_UPLOAD_SEARCH_INV_PH")}
                  prefix={<SearchOutlined />}
                  className="search-input"
                  onChange={(e) => setSearchText(e.target.value)}
                  value={searchText}
                />
              </Col>)}

              {/* Date Range */}

              <Col xs={24} md={10} lg={8}>
                <RangePicker
                  format={format}
                  style={{ width: "100%" }}
                  onChange={handleDateChange}
                  value={
                    formFilterState.fromDate && formFilterState.toDate
                      ? [
                          dayjs.utc(formFilterState.fromDate),
                          dayjs.utc(formFilterState.toDate),
                        ]
                      : [null, null]
                  }
                  placeholder={[
                    t("LOADS_FILTER_START_DATE"),
                    t("LOADS_FILTER_END_DATE"),
                  ]}
                  allowClear={false}
                  inputReadOnly
                />
              </Col>

              {/* Invoice Status Select */}
              {activeTab === "submitted" && (
                <>
                <Col xs={24} md={6} lg={4}>
                  <Select
                    placeholder={t("INV_UPLOAD_INV_STATUS_PH")}
                    style={{ width: "100%" }}
                    value={formFilterState.invoiceStatus || undefined}
                    onChange={(value) => {
                      setFormFilterState((prev) => ({
                        ...prev,
                        invoiceStatus: value,
                      }));
                    }}
                    allowClear
                    loading={statusLoading}
                  >
                    {/* <Option value="Approved">Approved</Option>
                  <Option value="Verification In Progress">
                    Verification In Progress
                  </Option>
                  <Option value="Rejected">Rejected</Option> */}
                    {invoiceStatusList.map((status) => (
                      <Option key={status.value} value={status.value}>
                        {status.name}
                      </Option>
                    ))}
                  </Select>
                </Col>
               </>
              )}
               <Col>
               <Button type="primary" size="large" onClick={handleApplyFilter}>{t("INV_UPLOAD_APPLY_FILTER_BTN")}</Button>
               &nbsp;&nbsp;&nbsp;&nbsp;
               {activeTab === "submitted" && (<Button size="large" onClick={handleResetFilter}>{t("INV_UPLOAD_RESET_FILTER_BTN")}</Button>)}
               </Col>
            </Row>

            <Spin spinning={loading}>
              <Row justify={'start'} style={{marginTop:"0.8rem",marginLeft:"1rem"}}>
                  <Col>
              <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={totalRecord}
                  onChange={handleChangePage}
                  showSizeChanger={false}
                />
                </Col>
                </Row>
              <div className="card-container">
                {invoiceList?.length ? (
                  invoiceList.map((item, index) => (
                    <InvoiceCard
                      key={item?.invoiceId}
                      item={item}
                      onClick={() => {
                        setSelectedHeaderInvoiceId(item?.invoiceId);
                        handleInvoiceClick(item?.id);
                      }}
                      userData={user}
                    />
                  ))
                ) : (
                  // <div className="no-data">No invoices found</div>
                  <div className="empty-list-wrapper">
                    <div className="add-invoice-wrapper">
                      <div className="request-your-payment">
                        <div>
                          <img src={addFrame} />
                        </div>
                        <div className="payment-request">
                          {t("INV_UPLOAD_NO_DATA_MSG_ONE")}
                        </div>
                        <div className="payment-desc">
                          {t("INV_UPLOAD_NO_DATA_MSG_TWO")}
                        </div>
                        <Button
                          className="add-new-btn"
                          onClick={handleAddInvoice}
                        >
                          <img src={plus} alt="+" />
                          {t("INV_UPLOAD_NO_DATA_ADD_INVOICE_BTN")}
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              
            </Spin>
          </div>
      </div>
      {/*  */}
      <Drawer
        className="invoice-drawer"
        width={1000}
        open={drawerOpen}
        onClose={onClose}
        closable={false}
        title={
          <>
          <div className="drawer-header">
            <CloseOutlined className="drawer-close" onClick={onClose} />
            <span className="drawer-title">
              {t("INV_UPL_SUB_MODAL_INVOICE_ID")} {selectedHeaderInvoiceId}
            </span>
          </div>
            <div style={{marginLeft:"2rem"}}>
              <span className="move-type-title">{invoiceDetails?.moveType}</span>
            </div>
            </>
        }
        // extra={
        //   <Button type="link" className="help-btn">
        //     Need Help?
        //   </Button>
        // }
        style={{
          background: "#FFFFFF",
          height:'100%',
        }}
      >
        <Spin spinning={detailsLoading} style={{height:'100%'}} className="spinner-custom">
          <InvoiceDetailsDrawerContent
            data={invoiceDetails}
            onOrderClick={handleOrderClick}
            userData={user}
          />
        </Spin>
      </Drawer>

      <TripDetailsModal
        open={tripModalOpen}
        onClose={() => setTripModalOpen(false)}
        data={selectedOrder}
        userData={user}
      />
    </>
  );
};
export default EarningInvoice;
